import './header.js';
import './headerMegamenuService.js';
import './tagSelector.js';
import './audioPlayer.js';
import './filter.js';
import './socialShare.js';
import './tableOfContents.js';

document.documentElement.classList.remove('no-js');

addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('loading');
});

if (document.querySelector('.js-card-tag-keys')) {
  import('./cardTagKeys.js').then(mod => {
    mod.default();
  });
}

if (document.querySelector('.js-magazine-filter-trigger')) {
  import('./magazineFilterModal.js').then(mod => {
    mod.default();
  });
}

if (document.querySelector('.js-magazine-summary-trigger')) {
  import('./magazineSummaryModal.js').then(mod => {
    mod.default();
  });
}

if (document.querySelector('.p-tags-archive')) {
  const tagsEl = document.querySelector('.p-tags-archive');
  document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      import('gsap').then(({ gsap }) => gsap.set(tagsEl, { opacity: 1 }));
    } else {
      import('gsap').then(({ gsap }) =>
        gsap.to(tagsEl, {
          opacity: 1,
          ease: 'power3.out',
          duration: 0.8,
          delay: 0.2,
        })
      );
    }
    window.addEventListener('pageshow', e => {
      if (e.persisted) {
        import('gsap').then(({ gsap }) => gsap.set(tagsEl, { opacity: 1 }));
      }
    });
  });
}

if (document.querySelector('.js-tags-filter-trigger')) {
  import('./tagsFilterModal.js').then(mod => {
    mod.default();
  });
}

if (document.querySelector('.js-tags-service-slider')) {
  import('./tagsSlider.js').then(mod => {
    mod.default();
  });
}

if (document.querySelector('.l-section--magazine-after-hero')) {
  import('./animation/magazineAnim.js');
}

if (document.querySelector('.js-policy-nav')) {
  import('./page/policy-detail.js');
}

// Get In Touch（表示対象ページのみ）
if (document.querySelector('.js-get-in-touch')) {
  import('./getInTouch.js').then(mod => mod.default());
}

// フッター絵文字カーソル（全ページ共通）
if (document.querySelector('.js-footer-marquee')) {
  import('./footerAnim.js').then(mod => mod.default());
}

// Cookie同意再表示リンクのキーボード操作対応（メンテナンスページ含む全ページ共通）
if (document.querySelector('[data-id="cookie_consent_cookie_btn"]')) {
  import('./cookieConsentLink.js').then(mod => mod.default());
}

// ページ見出しイントロ（--heading バリアント使用ページ共通）
if (document.querySelector('.js-page-title-en')) {
  import('./animation/pageTitleIntro.js');
}

if (document.querySelector('.l-main--works-detail')) {
  import('./worksDetailAnim.js').then(mod => mod.default());
}

if (document.querySelector('.l-main--magazine-detail')) {
  import('./magazineDetailAnim.js').then(mod => mod.default());
}

if (document.querySelector('.l-main--news-detail')) {
  import('./newsDetailAnim.js').then(mod => mod.default());
}

if (document.querySelector('.js-opinion-history-toggle')) {
  import('./opinionUpdateHistory.js').then(mod => mod.default());
}

if (document.querySelector('.js-opinion-quote-source')) {
  import('./opinionQuoteShare.js').then(mod => mod.default());
}

if (document.querySelector('.l-main--tips-detail')) {
  import('./tipsDetailAnim.js').then(mod => mod.default());
}
